import { useI18nContext } from './I18nProvider';

/**
 * Custom hook for accessing translations
 * @returns Translation function that accepts a key and optional interpolation options
 */
export const useTranslate = () => {
  const context = useI18nContext();
  if (context === undefined) {
    throw new Error('useTranslate must be used within an I18nProvider');
  }
  return context.t;
};
